import React, { useState } from "react";

// Click-to-load YouTube facade.
//
// The real YouTube embed pulls ~800 KB of JS/CSS and sets tracking cookies on
// first paint. This renders only a lightweight thumbnail + play button, and
// swaps in the actual iframe (autoplaying, so the click still starts the video)
// the moment the user clicks. Uses youtube-nocookie.com to defer cookies too.
//
// Designed to fill an aspect-ratio box: the parent should be `relative` with a
// padding-bottom hack (or fixed height); this component is absolutely filled.
const LiteYouTube = ({ id, title = "YouTube video" }) => {
  const [activated, setActivated] = useState(false);

  if (activated) {
    return (
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setActivated(true)}
      aria-label={`Play video: ${title}`}
      className="group absolute inset-0 w-full h-full cursor-pointer overflow-hidden"
    >
      <img
        src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <span className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-red-600 group-hover:bg-red-700 shadow-lg transition-colors duration-300">
          <svg className="w-8 h-8 md:w-10 md:h-10 text-white ml-1" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
      </span>
    </button>
  );
};

export default LiteYouTube;
